module.exports = __webpack_public_path__ + "img/gift4-01-c03-y1.a0618fe9.png";